import { DataBean } from "../DataBean";

export class Updateschema extends DataBean {



    public async updateTaxSchemaValuesForUBLInvoice(idUBLInvoice: any, issueDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateTaxSchemaValuesForUBLInvoice_Number_java.util.Date", [idUBLInvoice, issueDate]);
    }

}
